import { authStore } from '@tom-ui/utils'
import { ContainerTurnoverApi, ContainerTurnoverInternalQueryResult } from '../app/api'
import { createApiClient } from '../app/http-client'

class ContainerTurnoverService {
  httpClient = createApiClient(ContainerTurnoverApi)

  getByFilter = async (containerId: number): Promise<ContainerTurnoverInternalQueryResult[]> => {
    const { data } = await this.httpClient.integrationApiInternalContainerTurnoverGet(
      containerId,
      authStore.tenantId,
    )

    return data
  }
}

const containerTurnoverService = new ContainerTurnoverService()

export default containerTurnoverService
